const IP_URL = process.env.REACT_APP_NODE_API_URL;

export const initializeApplication = async (
  user_id,
  application_id,
  token_jwt 
) => {
  try {
    const response = await fetch(IP_URL + "api_login/initializeApplication", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        user_id: user_id,
        application_id: application_id,
        token: token_jwt,
      }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al iniciar sesión", error);
  }
};

export const joinApplication = async (
  userId,
  selectedApp,
  applicationList,
  navigate,
  isNavigate = true
) => {
  if (!selectedApp) {
    console.warn("No se ha seleccionado una aplicación.");
    return;
  }

  try {
    //console.log("Ingresando a la aplicación:", selectedApp);
    const tokenAccessApi = localStorage.getItem("token_jwt");
    const resultApp = await initializeApplication(
      userId,
      selectedApp.value,
      tokenAccessApi
    );

    if (!resultApp || !resultApp.user_info) {
      //console.error("La respuesta de la API es inválida:", resultApp);
      return;
    }

    const info = resultApp.user_info;
    console.log('Los datos con permisos son: ', info)
    const appSelected = {
      value: info.application_info.application_id,
      label: info.application_info.application_name,
    };

    const dataByApp = {
      user_id: info.user_id,
      user_name: info.user_name,
      user_rol: info.user_rol,
      application_info: info.application_info,
      application_menu: info.application_menu, // corregido
      application_sub_menu: info.application_sub_menu,
      application_selected: appSelected,
      application_list: applicationList,
      login_sesion_id: info.login_id,
      permissions_app: info.permission_app
    };
    if(!isNavigate){
      return dataByApp
    }
    navigate("/main_app", { state: { data: dataByApp }, replace: true });
  } catch (error) {
    console.error("Error al ingresar a la aplicación:", error);
  }
};
